import { authenticatedDelete } from '../../../api/utils/request';

export default async function deleteUser(idUser, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede eliminar la usuario');
    return await authenticatedDelete(`/auth/${idUser}`, onError);
}
